"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOptionsOfProduct = fetchOptionsOfProduct;
exports.optionsOfProductSaga = optionsOfProductSaga;

var _axios = _interopRequireDefault(require("react-platform-components/dist/axios"));

var _Utils = require("react-platform-components/dist/Utils");

var _effects = require("redux-saga/effects");

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchOptionsOfProduct),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(optionsOfProductSaga);

// Action to fetch specificities
function fetchOptionsOfProduct(action) {
  var params, response;
  return regeneratorRuntime.wrap(function fetchOptionsOfProduct$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)({
            type: 'FETCH_OPTIONS_OF_PRODUCT_START'
          });

        case 2:
          _context.prev = 2;
          params = action.params || {}; // Trigger get on endpoint 'option-of-products'

          _context.next = 6;
          return _axios.default.get("".concat(_config.BASE_API_URL, "option-of-products"), {
            params: params
          });

        case 6:
          response = _context.sent;
          _context.next = 9;
          return (0, _effects.put)({
            type: 'FETCH_OPTIONS_OF_PRODUCT_SUCCESS',
            payload: response.data
          });

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          _context.next = 15;
          return (0, _effects.all)([(0, _effects.put)({
            type: 'FETCH_OPTIONS_OF_PRODUCT_FAILURE'
          }), (0, _effects.put)({
            type: 'HANDLE_ERROR',
            error: (0, _Utils.handleErrors)(_context.t0)
          })]);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 11]]);
}

function optionsOfProductSaga() {
  return regeneratorRuntime.wrap(function optionsOfProductSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.all)([(0, _effects.takeEvery)('FETCH_OPTIONS_OF_PRODUCT', fetchOptionsOfProduct)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}